(function () {
  'use strict';
  function norm(value) { return String(value == null ? '' : value).trim().toLowerCase(); }
  function options(variant) { return variant.options || [variant.option1, variant.option2, variant.option3]; }
  function create(root, variants) {
    var node = root.querySelector('[data-ura-system-config]');
    if (!node) return null;
    var data;
    try { data = JSON.parse(node.textContent); } catch (error) { return null; }
    if (!data.profile || data.profile.schema_version !== 1 || data.profile.kind !== 'set') return null;
    var profile = data.profile;
    var components = profile.components;
    var bundles = Array.isArray(data.bundleVariants) ? data.bundleVariants : [];
    var names = data.optionNames.map(norm);
    var colorIndex = names.indexOf(norm(profile.purchase.color_option));
    var sizeIndex = names.indexOf(norm(profile.purchase.size_option));
    var modeIndex = names.indexOf(norm(profile.purchase.option_name));
    // If a retired native bundle is absent, buy the actual component variants together.
    if (!bundles.length && components.length > 1) {
      var seen = {};
      bundles = variants.reduce(function(result, variant) {
        var opts = options(variant);
        var key = JSON.stringify([norm(opts[colorIndex]), norm(opts[sizeIndex])]);
        if (seen[key]) return result;
        seen[key] = true;
        var pieces = components.map(function(c) {
          return variants.find(function(candidate) {
            var values = options(candidate);
            return norm(values[colorIndex]) === norm(opts[colorIndex]) &&
              norm(values[sizeIndex]) === norm(opts[sizeIndex]) && norm(values[modeIndex]) === norm(c.option_value);
          });
        });
        if (pieces.some(function(piece) { return !piece; })) return result;
        result.push({id:pieces[0].id, options:[opts[colorIndex],opts[sizeIndex]],
          available:pieces.every(function(piece) { return piece.available !== false; }),
          price:pieces.reduce(function(total,piece) { return total + Number(piece.price); },0),
          componentItems:pieces.map(function(piece) { return {id:piece.id,quantity:1}; })});
        return result;
      },[]);
    }
    var mode = new URL(window.location.href).searchParams.get('ura_buy') || 'set';
    if (!components.some(function(c) { return c.key === mode; })) mode = 'set';
    var callbacks = [];
    var buttons = Array.from(root.querySelectorAll('[data-ura-system-mode]'));
    var tabs = Array.from(root.querySelectorAll('[data-ura-system-fit-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-ura-system-fit-panel]'));
    var status = root.querySelector('[data-ura-system-fit-status]');
    var note = root.querySelector('[data-ura-system-mode-note]');
    var matches = {};
    var activeTab = components[0].key;
    var hooks = null;
    var fitApis = [];
    var fitSelection = false;
    function selected() {
      var values = [];
      root.querySelectorAll('[data-ura4-option]').forEach(function(group) {
        var checked = group.querySelector('[data-ura4-option-input]:checked');
        values[Number(group.dataset.optionIndex)] = checked ? checked.value : '';
      });
      return values;
    }
    function component(key) { return components.find(function(c) { return c.key === key; }); }
    function candidates(key, values, ignoreColor, ignoreSize) {
      var isSet = key === 'set';
      var c = component(key);
      return (isSet ? bundles : variants).filter(function(v) {
        var opts = options(v);
        return (ignoreColor || !values[colorIndex] || norm(opts[isSet ? 0 : colorIndex]) === norm(values[colorIndex])) &&
          (ignoreSize || !values[sizeIndex] || norm(opts[isSet ? 1 : sizeIndex]) === norm(values[sizeIndex])) &&
          (isSet || (c && norm(opts[modeIndex]) === norm(c.option_value)));
      });
    }
    function display(values, key) {
      var list = candidates(key || mode, values, false, !values[sizeIndex]);
      return list.find(function(v) { return v.available !== false; }) || list[0] || null;
    }
    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(Number(cents) / 100);
    }
    function showTab(key) {
      activeTab = key;
      tabs.forEach(function(tab) { tab.setAttribute('aria-pressed',String(tab.dataset.uraSystemFitTab === key)); });
      panels.forEach(function(panel) { panel.hidden = panel.dataset.uraSystemFitPanel !== key; });
    }
    function readySize() {
      if (mode !== 'set') return matches[mode] || '';
      var sizes = components.map(function(c) { return matches[c.key]; });
      return sizes.every(function(size) { return size && norm(size) === norm(sizes[0]); }) ? sizes[0] : '';
    }
    function fitStatus() {
      if (!status) return;
      var count = components.filter(function(c) { return matches[c.key]; }).length;
      var ready = readySize();
      var text = mode !== 'set' ? '' : ready ? data.copy.fit_ready + ' ' + ready + '.' :
        count === components.length ? data.copy.fit_conflict : count ? data.copy.fit_next : data.copy.fit_both;
      if (mode === 'set' && count) text += ' ' + components.map(function(c) {
        var language = (document.documentElement.lang || 'en').slice(0,2);
        return (c.labels[language] || c.labels.en) + ': ' + (matches[c.key] || '··');
      }).join(' / ');
      status.textContent = text;
      status.hidden = !text;
    }
    function paint(values) {
      buttons.forEach(function(button) {
        var key = button.dataset.uraSystemMode;
        button.setAttribute('aria-pressed', String(key === mode));
        var v = display(values,key);
        var price = button.querySelector('[data-ura-system-price]');
        if (price) price.textContent = v ? money(v.price) : '';
      });
      if (note) { note.hidden = mode !== 'set'; note.textContent = data.copy.same_size; }
      tabs.forEach(function(tab) { tab.hidden = mode !== 'set'; });
      showTab(mode === 'set' ? activeTab : mode);
      fitStatus();
    }
    buttons.forEach(function(button) {
      button.addEventListener('click',function() {
        if (mode === button.dataset.uraSystemMode) return;
        mode = button.dataset.uraSystemMode;
        if (hooks && fitSelection) hooks.clearAutomaticSize();
        fitSelection = false;
        paint(selected());
        callbacks.forEach(function(callback) { callback(); });
      });
    });
    tabs.forEach(function(tab) { tab.addEventListener('click',function() { showTab(tab.dataset.uraSystemFitTab); }); });
    paint(selected());
    return {
      mode:function() { return mode; },
      resolve:function(values) { return values[sizeIndex] ? display(values) : null; },
      display:function(values) { return display(values); },
      galleryVariant:function(values) {
        return candidates(mode === 'set' ? components[0].key : mode, values, false, !values[sizeIndex])[0] || variants[0];
      },
      updateOptions:function(groups,values) {
        groups.forEach(function(group) {
          var index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-ura4-option-input]').forEach(function(input) {
            if (index !== colorIndex && index !== sizeIndex) { input.disabled = false; return; }
            var probe = values.slice(); probe[index] = input.value;
            input.disabled = !candidates(mode,probe,false,index === colorIndex).some(function(v) { return v.available !== false; });
          });
        });
        paint(values);
      },
      onChange:function(callback) { callbacks.push(callback); },
      initFit:function(purchaseHooks) {
        hooks = purchaseHooks;
        if (!window.URAProductFitV4) return null;
        components.forEach(function(c) {
          var panel = panels.find(function(p) { return p.dataset.uraSystemFitPanel === c.key; });
          if (!panel) return;
          var api = window.URAProductFitV4.init(root, {
            isSizeAvailable:function(size) {
              var values = selected(); values[sizeIndex] = size;
              return candidates(mode === 'set' ? 'set' : c.key,values,false,false).some(function(v) { return v.available !== false; });
            },
            selectSize:function(size) {
              matches[c.key] = size;
              fitStatus();
              if (mode !== 'set' && mode !== c.key) return false;
              var shared = readySize();
              if (!shared) {
                if (fitSelection) hooks.clearAutomaticSize();
                fitSelection = false;
                return false;
              }
              fitSelection = hooks.selectSize(shared,true);
              return fitSelection;
            },
            markRecommendation:function() { if (fitSelection && readySize()) hooks.markRecommendation(readySize()); },
            clearRecommendation:function() { if (mode === 'set' || mode === c.key) hooks.clearRecommendation(); },
            clearAutomaticSize:function() {
              delete matches[c.key];
              if ((mode === 'set' || mode === c.key) && fitSelection) { hooks.clearAutomaticSize(); fitSelection = false; }
              fitStatus();
            },
            continueToPurchase:function() {
              if (fitSelection && readySize()) { hooks.continueToPurchase(); return; }
              if (mode === 'set') {
                var next = components.find(function(item) { return !matches[item.key]; });
                if (next) showTab(next.key);
              }
            }
          },panel.querySelector('[data-ura4-fit]'));
          if (api) fitApis.push(api);
        });
        return {
          refresh:function() { fitApis.forEach(function(api) { api.refresh(); }); fitStatus(); },
          manualSelection:function() { fitSelection = false; fitApis.forEach(function(api) { api.manualSelection(); }); }
        };
      }
    };
  }
  window.URAProductSystemV1 = {create:create};
}());

